// AppInsights.ts
// for setup and configuration see https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript-react-plugin

import { ApplicationInsights, Snippet } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { history } from 'app/store';
import { Constants } from './Constants';

const reactPlugin = new ReactPlugin();
let appInsights = new ApplicationInsights({
    config: {
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: history }
        }
    }
})


const RegisterApplicationInsights = (connectionString: string) => {
    appInsights = new ApplicationInsights({
        config: {
            connectionString: connectionString,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: { history: history }
            }
        }
    })
    appInsights.loadAppInsights();

    // prevent certain telemetry from being sent by returning false
    appInsights.addTelemetryInitializer((item) => {
        // BCBSSC regular users have an extension that causes an exception:
        // before the code manages to finish the service cycle, another one is queued or ignored.
        // ResizeObserver loop completed with undelivered notifications.
        // ResizeObserver loop limit exceeded
        if (item?.data?.message?.includes('ResizeObserver loop'))
            return false;

        return true;
    });

    console.debug("[appl] AppInsight.RegisterApplicationInsights")
}


export { reactPlugin, appInsights, RegisterApplicationInsights };